import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import history from '../../../utilites/history';
import { getRoutesByLanguage } from "../../../utilites/util";
import { setActiveLanguage } from "./actions";

const languageMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.LANGUAGE.CHANGE:

    const currentQuery = history.location.search;

    history.push({
      pathname: getRoutesByLanguage(action.payload.language),
      search: currentQuery,
    });

    next(setActiveLanguage(action.payload));
    break;
  }
};

export default languageMiddleware;
